// import React, { useState, useEffect, memo } from 'react';

// const TimeInputField = memo(({
//   icon: Icon,
//   name,
//   label,
//   value,
//   onChange,
//   error,
//   disabled
// }) => {
//   const [time, setTime] = useState('');

//   useEffect(() => {
//     if (value) {
//       // Expect value like "14:30:45"
//       setTime(value);
//     }
//   }, [value]);

//   const handleTimeChange = (e) => {
//     const newTime = e.target.value; // "HH:mm:ss"

//     setTime(newTime);

//     onChange({
//       target: {
//         name,
//         value: newTime,
//       },
//     });
//   };

//   return (
//     <div>
//       <label className="block mb-1 text-sm font-medium text-blue-200">
//         {Icon && (
//           <Icon className="inline w-4 h-4 mr-1 text-blue-400" />
//         )}
//         {label?.replace('*', '')}
//         {label?.includes('*') && (
//           <span className="text-lg text-red-400/70">*</span>
//         )}
//       </label>

//       <input
//         type="time"
//         step="1"               // Enables seconds
//         name={name}
//         value={time}
//         onChange={handleTimeChange}
//         disabled={disabled}
//         className={`date-input w-full px-4 py-2.5 bg-white/5 border ${
//           error ? 'border-red-500/50' : 'border-blue-500/30'
//         } rounded-xl focus:outline-none focus:border-blue-400 text-white text-sm ${
//           disabled ? 'opacity-50 cursor-not-allowed' : ''
//         }`}
//       />

//       {error && (
//         <p className="mt-1 text-xs text-red-400">{error}</p>
//       )}
//     </div>
//   );
// });

// export default TimeInputField;


import React, { useState, useEffect, memo } from 'react';

const TimeInputField = memo(({
  icon: Icon,
  name,
  label,
  value,
  onChange,
  error,
  disabled,
  theme
}) => {
  const [time, setTime] = useState('');
  const isDark = theme === 'dark';

  useEffect(() => {
    if (value) {
      setTime(value);
    }
  }, [value]);

  const handleTimeChange = (e => {
    const newTime = e.target.value;
    setTime(newTime);
    onChange({
      target: {
        name,
        value: newTime,
      },
    });
  });

  // Theme-aware classes
  const bgInput = isDark ? 'bg-white/5' : 'bg-gray-100/80';
  const borderInput = isDark ? 'border-blue-500/30' : 'border-gray-300';
  const borderError = isDark ? 'border-red-500/50' : 'border-red-400';
  const borderFocus = isDark ? 'focus:border-blue-400' : 'focus:border-blue-500';
  
  const textColor = isDark ? 'text-white' : 'text-gray-900';
  const labelColor = isDark ? 'text-blue-200' : 'text-gray-700';
  const iconColor = isDark ? 'text-blue-400' : 'text-blue-600';
  const errorColor = isDark ? 'text-red-400' : 'text-red-600';
  
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <div>
      <label className={`block mb-1 text-sm font-medium ${labelColor}`}>
        {Icon && (
          <Icon className={`inline w-4 h-4 mr-1 ${iconColor}`} />
        )}
        {label?.replace('*', '')}
        {label?.includes('*') && (
          <span className="text-lg text-red-400/70">*</span>
        )}
      </label>

      <input
        type="time"
        step="1"
        name={name}
        value={time}
        onChange={handleTimeChange}
        disabled={disabled}
        className={`date-input w-full px-4 py-2.5 ${bgInput} border ${
          error ? borderError : borderInput
        } ${borderFocus} rounded-xl focus:outline-none ${textColor} text-sm ${disabledStyles} transition-colors duration-300`}
      />

      {error && (
        <p className={`mt-1 text-xs ${errorColor}`}>{error}</p>
      )}
    </div>
  );
});

export default TimeInputField;